import i18next, { i18n as i18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { languages } from "./i18n.constants";
import { th, en } from "./i18n.translations";
const param_customer = localStorage.getItem("param_customer");
console.log('param_customerparam_customer',param_customer);

const createI18n = (language: string): i18nInstance => {
  const i18n = i18next.createInstance().use(initReactI18next);

  i18n.init({
    lng: language,
    fallbackLng: language,
    resources: {
      [languages.en]: en,
      [languages.th]: th,
    },
  });
  return i18n;
};

export const i18n = createI18n(param_customer === 'undefined' || param_customer === null ? languages.th: languages.en);